import { useDispatch, useSelector } from 'react-redux';
import usePreprocess from '~/components/account/my-notifications/utils/usePreprocess';
import { showNotification } from '~/components/notifications/ducks/notifications';
import { useCallback, useEffect } from 'react';
import { notificationBluebarClicked, notificationBluebarClosed } from '@comeon/analytics';
import { updateBluebarNotification } from '~/components/account/my-notifications/ducks/my-notifications';
import { useRouter } from '~/utils/navigation';

const MyNotificationBluebar = () => {
	const router = useRouter();
	const dispatch = useDispatch();
	const bluebarNotification = useSelector(state => state.myNotifications.bluebarNotification);
	const processedNotification = usePreprocess(bluebarNotification);

	const showNotificationBluebar = useCallback(
		(popupData, id) => {
			const bluebarCallbackFunction = outsideCTA => () => {
				notificationBluebarClicked(outsideCTA, id);
				if (popupData.ctaUrlType === `external`) {
					if (popupData?.ctaUrlPresetType && Number.parseInt(popupData.ctaUrlPresetType, 10) === 11) {
						window.open(popupData.ctaUrl, '_blank');
					} else {
						window.location.href = popupData.ctaUrl;
					}
				} else if (popupData.ctaUrlType === `comeon-external`) {
					window.location.href = window.location.origin + popupData.ctaUrl;
				} else {
					router.push(popupData.ctaUrl);
				}
			};

			const bluebarObject = {
				color: 'neutral',
				autoHide: true,
				autoHideDuration: 10000,
				onCloseClickCallback: () => {
					notificationBluebarClosed(id);
					dispatch(updateBluebarNotification(null));
				},
				onClose: () => {
					dispatch(updateBluebarNotification(null));
				},
				buttonCB: bluebarCallbackFunction(),
				onBluebarClick: bluebarCallbackFunction(true)
			};

			try {
				// If we can parse the data, the data is already in object form
				const parsedData = JSON.parse(popupData.title);

				// Content is in the new RICH TEXT FORMAT
				bluebarObject.message = parsedData.text;
			} catch (e) {
				// Content is NORMAL TEXT: [OLDER FORMAT]
				// Handle the older format of notification data
				// If we cant parse the data, the data is still in the old format,
				// we just need to format the text in the correct field
				bluebarObject.message = popupData.title;
			}

			bluebarObject.buttonText = popupData.ctaText;

			dispatch(showNotification(bluebarObject));
		},
		[dispatch, router]
	);

	useEffect(() => {
		if (processedNotification) {
			showNotificationBluebar(processedNotification.notificationPopUp, processedNotification.id);
		}
	}, [processedNotification, showNotificationBluebar]);

	return null;
};

export default MyNotificationBluebar;
